import { categories } from '@/mocks/categories';

const showcaseImages: Record<string, string> = {
  shoes: 'https://readdy.ai/api/search-image?query=Fresh%20white%20minimalist%20sneakers%20displayed%20on%20concrete%20surface%20with%20natural%20sunlight%20casting%20soft%20shadows%2C%20clean%20editorial%20product%20photography%2C%20modern%20lifestyle%20aesthetic%2C%20warm%20cream%20background%2C%20premium%20catalog%20quality&width=800&height=1067&seq=cat-shoes-v2-2026&orientation=portrait',
  'hoodies-sweaters': 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20cream%20colored%20hoodie%20draped%20artistically%20on%20wooden%20chair%2C%20soft%20morning%20light%20through%20window%2C%20minimalist%20Scandinavian%20interior%2C%20warm%20beige%20tones%2C%20textural%20fabric%20details%2C%20lifestyle%20product%20photography&width=800&height=1067&seq=cat-hoodies-v2-2026&orientation=portrait',
  't-shirts': 'https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t%20shirt%20neatly%20folded%20on%20linen%20fabric%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20composition%2C%20clean%20aesthetic%2C%20warm%20neutral%20palette%2C%20professional%20product%20photography%2C%20elegant%20simplicity&width=800&height=1067&seq=cat-tshirts-v2-2026&orientation=portrait',
};

export default function CategoryShowcase() {
  const featured = categories.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <h2 className="text-4xl md:text-5xl lg:text-6xl text-foreground-900 text-center mb-16"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Find Your Style
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-[1.02] aspect-[3/4]"
            >
              <img
                src={showcaseImages[cat.slug]}
                alt={`${cat.name} category - AllChinaBuySpreadsheet`}
                title={`${cat.name} Products Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-white text-2xl md:text-3xl font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
                  {cat.name}
                </p>
                <p className="text-white/70 text-sm mt-1">{cat.description}</p>
              </div>
              {cat.tag && (
                <span className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
                  {cat.tag}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}